import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import ConfigPage from "./containers/config/ConfigPage";

/* Tiny path switch instead of a router — the site has exactly one extra page.
   /config is deliberately unlinked from the portfolio; it is reachable only by
   typing the URL. public/404.html restores the path on GitHub Pages, which has
   no server-side routing. */
function App() {
  const path = window.location.pathname.replace(/\/+$/, "").toLowerCase();

  if (path === "/config") {
    return <ConfigPage />;
  }

  return (
    <div>
      <Main />
    </div>
  );
}

export default App;
